/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/xaut.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const xautPage: ICoinPageData = {
  title: 'coin_1134',
  description: 'coin_1135',
  // description: 'coin_1136',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'XAUt' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_1137',
        answer: 'coin_1138',
      },
      {
        title: 'coin_1139',
        answer: 'coin_1140',
      },
      {
        title: 'coin_1141',
        answer: 'coin_1142',
      },
      {
        title: 'coin_1143',
        answer: 'coin_1144',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('FLR'),
    text: [],
    paragraphs: [
      {
        title: 'coin_1145',
        text: ['coin_1147'],
      },
      {
        title: 'coin_1146',
        text: ['coin_1148'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-types-of-crypto-loans-are-there-and-how-can-i-profit-from-it/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/12/1.png',
        imageAlt: 'Hold XAUt & Gain profit',
      },
      {
        link: 'https://coinrabbit.io/blog/usdc-vs-usdt-which-stablecoin-to-use/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2048/https://coinrabbit.io/blog/wp-content/uploads/2023/09/will-be-listed-2048x1072.jpg',
        imageAlt: 'Hold XAUt & Gain profit',
      },
      blogCards.borrowLikePro,
    ],
  },
}
